import { Transaction } from './transaction';

export class Reservation extends Transaction {
  eventReservationId: number;
  status: string;
  source: string;
  rooms: number;
  roomNights: number;
  ratePlanCode: string;
  groupCode: string;
}

export class TransientReservation extends Reservation {
  selected: boolean;
  chainCode: string;
  brandCode: string;
  property: string;
  ratePlanCode: string;
  paymentRecordNumber: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/reservation.ts